module.exports = __webpack_public_path__ + "img/digital_space_bg_bottom.ac9c2c06.svg";